import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { RoleTable, useRoleList } from '@/features/access-control';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/access-management/')({
  component: AccessManagementPage,
});

function AccessManagementPage() {
  const { t } = useTranslation('accessControl');
  const { roles, isLoading } = useRoleList();

  return (
    <div className="flex flex-col gap-lg">
      <PageHeader title={t('roles.title')} subtitle={t('roles.subtitle')} />

      <RoleTable roles={roles} isLoading={isLoading} />
    </div>
  );
}
